import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { CHANNELS } from '../../constants/channels';

const { Option } = Select;

const Channels = () => {
    const { t } = useTranslation('forms', { keyPrefix: 'FORMS.INPUTS' });
    const { t: tr } = useTranslation('forms', { keyPrefix: 'FORMS.RULES' });

    const RULES = [{ required: true, message: tr('REQUIRED_FIELD') }];

    return (
        <Form.Item
            label={t('WEBINARS.CHANNEL_TRANSMISSIONS')}
            name="channels"
            rules={RULES}
        >
            <Select
                mode="multiple"
                defaultValue={['FACEBOOK']}
            >
                {
                    CHANNELS.map((channel, index) => (
                        <Option value={channel} key={index}>
                            {channel.toLowerCase()}
                        </Option>
                    ))
                }
            </Select>
        </Form.Item>
    );
};

export default Channels;
